import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DndModule } from 'ngx-drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';
import { SharedModule } from '../shared/shared.module';
import { GeneratedCodeModalComponent } from './generated-code-modal/generated-code-modal.component';
import { FormBuilderComponent } from 'draganddrop';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [    
    GeneratedCodeModalComponent,
    FormBuilderComponent 
  ],
  imports: [
    CommonModule,
    FormsModule,    
    DndModule,
    NgbModule,
    SharedModule,
    ColorPickerModule,
    TranslateModule
  ],
  exports: [
    FormBuilderComponent, // Add other components here
  ],
  providers: []
})
export class FormBuilderModule {}
